import { Component, OnInit } from '@angular/core';
import { ReportesService } from 'src/app/services/reportes/reportes.service';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-layout-alta-proveedores',
  templateUrl: './layout-alta-proveedores.component.html',
  styleUrls: ['./layout-alta-proveedores.component.css']
})
export class LayoutAltaProveedoresComponent implements OnInit {
  fechaInicio: string = '';
  fechaFin: string = '';
  datos: any[] = [];
  columnas = [
    { field: 'clave_id', header: 'Clave ID' },
    { field: 'operacion', header: 'Operacion' },
    { field: 'nombre_contributor', header: 'Nombre' },
    { field: 'rfc_contributor', header: 'RFC' },
    { field: 'telefono_contributor', header: 'Telefono' },
    { field: 'contacto', header: 'Contacto' },
    { field: 'correo_contritbutor', header: 'email' },
    { field: 'tipo_cuenta', header: 'Tipo Cuenta' },
    { field: 'moneda', header: 'Moneda' },
    { field: 'banco_contritbuor', header: 'Banco' },
    { field: 'clabe_contributor', header: 'Cuenta/CALBE' }
  ];
  constructor(private _reportesservice: ReportesService) { }

  ngOnInit(): void {
  }

generarReporte() {
    if (!this.fechaInicio || !this.fechaFin) {
      Swal.fire('Error', 'Selecciona ambas fechas', 'error');
      return;
    }

    Swal.fire({
      title: 'Consultando...',
      didOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: false,
    });
    this._reportesservice.getLySimBanorte(this.fechaInicio, this.fechaFin)
      .subscribe({
        next: (respuesta: any[]) => {
          Swal.close();
          if (!respuesta || respuesta.length === 0) {
            Swal.fire('Sin datos', 'No se encontraron datos en el rango seleccionado', 'info');
            this.datos = [];
            return;
          }

          this.datos = respuesta;
        },
        error: (err) => {
          Swal.close();
          Swal.fire('Error', 'Ocurrió un error al consultar el reporte', 'error');
          console.error(err);
        }
      });
  }

  procesarValor(reg: any, field: string): string {
  switch (field) {
    case 'nombre_contributor':
      return reg.nombre_contributor ? reg.nombre_contributor.replace(/[.,;]/g, '').toUpperCase() : '';
    case 'contacto':
      return reg.nombre_contributor ? reg.nombre_contributor.replace(/[.,;]/g, '').toUpperCase().slice(0, 20) : '';
    case 'banco_contritbuor':
      return reg.banco_contritbuor ? reg.banco_contritbuor.padStart(4, '0') : '';
    default:
      return reg[field] ?? '';
  }
}

generarTxt() {
  //REGISTROS DE EJEMPLO
  /*const registros = [
    {
      banco_contritbuor: "HSBC México, S.A., institución De Banca Múltiple, Grupo Financiero HSBC",
      clabe_contributor: "021150065520988039",
      clave_id: "IDMEX2279004835",
      correo_contritbutor: "mrivero@esj.mx",
      customer_id: "5592ec1b-5991-4c57-ae39-28953439d6fa",
      gov_customer_id: null,
      moneda: "PESOS",
      nombre_contributor: "JOSE MANUEL DEL RIVERO MELENDEZ",
      operacion: "AR",
      rfc_contributor: "RIMM7107122L5",
      telefono_contributor: "",
      tipo_cuenta: "040"
    },
    {
      banco_contritbuor: "02",
      clabe_contributor: "002910905261115820",
      clave_id: "1618",
      correo_contritbutor: "alvaro_cobay1988@hotmail.com",
      customer_id: "5592ec1b-5991-4c57-ae39-28953439d6fa",
      gov_customer_id: null,
      moneda: "PESOS",
      nombre_contributor: "Alvaro Felipe Aguilar Quintal",
      operacion: "AR",
      rfc_contributor: "AUQA8811211A4",
      telefono_contributor: "9991029414",
      tipo_cuenta: "040"
    },
    {
      banco_contritbuor: "02",
      clabe_contributor: "002910905261115820",
      clave_id: "1618",
      correo_contritbutor: "alvaro_cobay1988@hotmail.com",
      customer_id: "5592ec1b-5991-4c57-ae39-28953439d6fa",
      gov_customer_id: null,
      moneda: "PESOS",
      nombre_contributor: "Alvaro Felipe Aguilar Quintal",
      operacion: "AC",
      rfc_contributor: "AUQA8811211A4",
      telefono_contributor: "9991029414",
      tipo_cuenta: "040"
    },
    {
      banco_contritbuor: "127",
      clabe_contributor: "127910001691259902",
      clave_id: "1568",
      correo_contritbutor: "carloepp@live.com.mx ",
      customer_id: "5592ec1b-5991-4c57-ae39-28953439d6fa",
      gov_customer_id: null,
      moneda: "PESOS",
      nombre_contributor: "CARLOS EDILBERTO PANTI PECH",
      operacion: "AR",
      rfc_contributor: "PAPC691018843",
      telefono_contributor: "9993230801",
      tipo_cuenta: "040"
    },
    {
      banco_contritbuor: "127",
      clabe_contributor: "127910001691259902",
      clave_id: "1568",
      correo_contritbutor: "carloepp@live.com.mx ",
      customer_id: "5592ec1b-5991-4c57-ae39-28953439d6fa",
      gov_customer_id: null,
      moneda: "PESOS",
      nombre_contributor: null,
      operacion: "AC",
      rfc_contributor: "PAPC691018843",
      telefono_contributor: "9993230801",
      tipo_cuenta: "040"
    }
  ];*/

  // 🟨 Campos que requieren apostrofe (para conservar ceros a la izquierda)
  const camposConApostrofe = ['clave_id', 'rfc_contributor', 'clabe_contributor'];

  // 🟩 Preparar datos para Excel (con encabezados personalizados)
  const datosExcel = this.datos.map(reg => {
    //const clabeFinal = ['AR', 'BR'].includes(reg.operacion) ? 'X' : reg.clabe_contributor;
    const nombreLimpio = reg.nombre_contributor ? reg.nombre_contributor.replace(/[.,;]/g, '').toUpperCase(): '';
    const contactoLimpio = nombreLimpio.slice(0, 20);
    const bancoFormateado = reg.banco_contritbuor ? reg.banco_contritbuor.padStart(4, '0') : '';
    return {
      'Clave ID': reg.clave_id,
      'Operacion': reg.operacion,
      'Nombre': nombreLimpio,//camposConApostrofe.includes('clabe_contributor') && clabeFinal !== 'X' ? `'${clabeFinal}` : clabeFinal,
      'RFC': reg.rfc_contributor,
      'Telefono': reg.telefono_contributor,
      'Contacto': contactoLimpio,
      'e-mail': reg.correo_contritbutor,
      'Tipo Cuenta': reg.tipo_cuenta,
      'Moneda': reg.moneda,
      'Banco': bancoFormateado,
      'Cuenta/CLABE': reg.clabe_contributor
    };
  });

  const worksheetExcel: XLSX.WorkSheet = XLSX.utils.json_to_sheet(datosExcel);
  const workbookExcel: XLSX.WorkBook = {
    Sheets: { 'Hoja1': worksheetExcel },
    SheetNames: ['Hoja1']
  };

  XLSX.writeFile(workbookExcel, 'banorte_simplificado_ctas_prov.xlsx', { cellStyles: true });

  // 🟦 Generar archivo TXT plano
  const datosTxt = this.datos.map(reg => {
    //const clabeFinal = ['AR', 'BR'].includes(reg.operacion) ? 'X' : reg.clabe_contributor;
    const nombreLimpio = reg.nombre_contributor ? reg.nombre_contributor.replace(/[.,;]/g, '').toUpperCase(): '';
    const contactoLimpio = nombreLimpio.slice(0, 20);
    const bancoFormateado = reg.banco_contritbuor ? reg.banco_contritbuor.padStart(4, '0') : '';
    return [
      reg.clave_id,
      reg.operacion,
      nombreLimpio,//camposConApostrofe.includes('clabe_contributor') && clabeFinal !== 'X' ? `'${clabeFinal}` : clabeFinal,
      reg.rfc_contributor,
      reg.telefono_contributor,
      contactoLimpio,
      reg.correo_contritbutor,
      reg.tipo_cuenta,
      reg.moneda,
      bancoFormateado,
      reg.clabe_contributor
    ];
  });

  const worksheetTxt: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(datosTxt);
  const txtContenido: string = XLSX.utils.sheet_to_csv(worksheetTxt, {
    FS: '\t',
    RS: '\n',
    strip: true,
    blankrows: false,
    skipHidden: true
  });

  const blob = new Blob([txtContenido], { type: 'text/plain;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'banorte_simplificado_ctas_prov.txt';
  a.click();
  window.URL.revokeObjectURL(url);
}

}
